import { matchPath } from 'react-router-dom';
import { loadRemoteModule } from '@mindtickle/ui-shell-core/DynamicRemote';
import loadScript from '@mindtickle/ui-shell-core/loadScript';
import { getExtendedLogger } from '@mindtickle/ui-shell-core/Logger';

// import { isAdminSite } from '~/utils';
import {
  // DYNAMIC_REMOTES,
  REMOTE_FILE,
  ROUTES_NAMESPACE,
  SHAREABLE_ROUTE_PREFIX_PATH,
} from '~/config/app.constants';
import logger from '~/config/app.logger';

const remotes = require('../../remotes.js');

interface remoteI {
  url: string;
  appName: string;
  remoteName: string;
  moduleName: string;
  path: string;
  host: string;
  isShareable: boolean;
  children?: ReadonlyArray<remoteI>;
}

export function prefetchRequiredApps() {
  const log = getExtendedLogger('prefetchRequiredApps', logger);

  const apps = [];
  const mainApps = getMainAppDetails(remotes);

  if (mainApps.length) {
    apps.unshift(
      ...mainApps.map(mainApp => ({
        ...mainApp,
        url: mainApp.host + '/' + REMOTE_FILE,
      }))
    );
  }

  apps.forEach(remote => {
    log('started', remote.url);
    // @ts-ignore
    if (!!remote.prefetchDisabled) {
      return;
    }
    let p1 = loadScript({
      url: remote.url,
      defer: true,
    }) as Promise<HTMLScriptElement>;

    p1.then(() => {
      loadRemoteModule(remote.remoteName, remote.moduleName);
      log('done', remote.url, remote.remoteName, remote.moduleName);
    });
  });
}

// function getSiblingAppDetails() {
//   if (isAdminSite()) {
//     return [DYNAMIC_REMOTES.ADMIN_HEADER];
//   } else {
//     return [DYNAMIC_REMOTES.LEARNER_HEADER, DYNAMIC_REMOTES.LEARNER_SIDEBAR];
//   }
// }

function getMainAppDetails(
  remotes: ReadonlyArray<remoteI>,
  pathToAppend: string = ''
): ReadonlyArray<remoteI> {
  for (let remoteIndex = remotes.length - 1; remoteIndex >= 0; remoteIndex--) {
    const remote = remotes[remoteIndex];
    const routePaths = getRemoteRoutePaths(remote, pathToAppend);

    const childApps = getChildrenAppDetails(remote);
    if (childApps.length) {
      return childApps;
    }

    if (routePaths.some(routePath => matchPath(routePath, window.location.pathname))) {
      return [remote];
    }
  }
  return [];
}

function getRemoteRoutePaths(remote: remoteI, pathToAppend: string = ''): ReadonlyArray<string> {
  const namespace = remote.isShareable ? SHAREABLE_ROUTE_PREFIX_PATH : ROUTES_NAMESPACE;
  const namespaces = Array.isArray(namespace) ? namespace : [namespace];
  return namespaces.map(ns => ns.replace('*', pathToAppend + remote.path));
}

function getChildrenAppDetails(remote: remoteI) {
  if (remote.children) {
    const childAppDetails = getMainAppDetails(remote.children, `${remote.path}/`);
    if (childAppDetails.length) {
      return [remote, ...childAppDetails];
    }
  }
  return [];
}
